import ValidationModule from "@/modules/validation/validation";
import {$t} from "@/i18n";

export const validateRecipients = (recipients) => {
    const errors = {}

    for (const recipientIndex in recipients) {
        const recipient = recipients[recipientIndex]

        if (recipient.email && !ValidationModule.validateEmail(recipient.email)) {
            errors[recipientIndex] = $t('Invalid email')
        }
    }

    return Object.keys(errors).length > 0 ? errors : null
}

export default {
    validateRecipients
}